<div class="rmg">
    <div >
  
      <nav class="navbar navbar-expand-sm  navbar-inverse" >
        <div class="container-fluid">
          <div class="navbar-header">
            <img src="assets\resource\favicon.ico" class="img-thumbnail" width="50" height="50" alt="brand image">
           &nbsp;
            <a class="navbar-brand text-light" href=" ">HOUSE OF BOOKS</a>
          </div>
        
        <ul class="navbar-nav offset-8 " *ngIf="cust==null">
          <li class="nav-item ">
            <a class="nav-link text-light" [routerLink]="'/signUp'">LOGIN / SIGN UP</a>
          </li>
          
        </ul>
        
     
        <ul class="navbar-nav"  *ngIf="cust!=null">
          
          <li class="nav-item dropleft" >
            <a class="nav-link dropdown-toggle text-light" id="navbardropdown" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{cust.customerName}} </a>
      
            <div class="dropdown-menu " style="opacity: 50%;" aria-labelledby="navbardropdown" > 
                <li class="dropdown-item">
                    <a  class="nav-link text-dark" [routerLink]="'/login'">Add /View Books</a>
                </li>
      
                <a (click)="logOut()"><li class="dropdown-item text-dark">
                    Logout
                </li></a>
            </div>
        </li>
      
        
      </ul>
        </div>
    
        
      </nav>
      
      </div>
       
      
      
      <div class=" container-fluid"><router-outlet ></router-outlet></div>
    
  </div>